import type { ImageLightOptions } from './types'

export const resolveImageRect = (sourceWidth: number, sourceHeight: number, targetWidth: number, targetHeight: number, options: ImageLightOptions) => {
  const fitMode = options.fitMode

  if (fitMode === 'stretch') {
    const width = targetWidth * options.scale
    const height = targetHeight * options.scale

    return {
      x: (targetWidth - width) / 2 + (targetWidth * options.offsetX) / 100,
      y: (targetHeight - height) / 2 + (targetHeight * options.offsetY) / 100,
      width,
      height,
    }
  }

  const scale = fitMode === 'contain' ? Math.min(targetWidth / sourceWidth, targetHeight / sourceHeight) : Math.max(targetWidth / sourceWidth, targetHeight / sourceHeight)
  const width = sourceWidth * scale * options.scale
  const height = sourceHeight * scale * options.scale

  return {
    x: (targetWidth - width) / 2 + (targetWidth * options.offsetX) / 100,
    y: (targetHeight - height) / 2 + (targetHeight * options.offsetY) / 100,
    width,
    height,
  }
}
